/**
 * @ngdoc service
 * @name BB.i18n.RuntimeTranslate
 *
 * @description
 * Returns an instance of $translateProvider that allows late language binding (on runtime)
 */

/**
 * @ngdoc service
 * @name BB.i18n.RuntimeTranslateProvider
 *
 * @description
 * Provider
 *
 * @example
 <pre>
 angular.module('ExampleModule').config ['RuntimeTranslateProvider', '$translateProvider', (RuntimeTranslateProvider, $translateProvider) ->
 RuntimeTranslateProvider.setProvider($translateProvider)
 ]
 </pre>
 */
function RuntimeTranslateProvider($translateProvider) {
    'ngInject';

    let translateProvider = $translateProvider;
    this.setProvider = provider => translateProvider = provider;
    this.$get = () => translateProvider;
}

export default RuntimeTranslateProvider;

angular
    .module('BB.i18n')
    .provider('RuntimeTranslate', RuntimeTranslateProvider);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-i18n/_services/runtime_translate.provider.js